import React, { Component } from "react";
import { Image, Dimmer, Label } from "semantic-ui-react";
/**
 *  Content Card: Content i.e., series, film or video that is rendered with a thumbail image and title
 * 		Usually used together with content list to show an array of content cards
 * 	Props: title, onClick( tiggers when card is clicked), image, tags
 */
class ContentCard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	handleShow = () => this.setState({ active: true });
	handleHide = () => this.setState({ active: false });

	render() {
		const { title, onClick, image, tags } = this.props;
		const { active } = this.state;
		let tagsList= undefined;
		if(tags!== undefined) {
			tagsList = tags.split(",");
		}
		return (
			<div style={styles.mainContainer}>
				<Dimmer.Dimmable
					// as={Card}
					dimmed={active}
					style={{ width: "auto", height: "700px" }}
					onClick={onClick}
					onMouseEnter={this.handleShow}
					onMouseLeave={this.handleHide}
				>
					<Image style={styles.imageContainer} src={image}  />
					<Dimmer active={active} 
						// style={{ opacity: 0.6 }}
					>
						<div>
							{tagsList===undefined ?
								// <Icon size="huge" name="video play" /> 
								<h3>{title}</h3>
								:
								<Label.Group>
									{
										tagsList.map( tag => (
											<Label key={tag}>{tag}</Label>
										))
									}
								</Label.Group>
							}
						</div>
						
					</Dimmer>
				</Dimmer.Dimmable>
			</div>
		);
	}
}

// Style definitions
const styles = {
	// container that wraps the title seach section
	imageContainer: {
		width: "auto",
		height: "700px",
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
	},
	mainContainer: {
		margin: '4px',
		marginBottom: '0px',
		cursor: 'pointer',
		display: 'inline-block',
	}
};
export { ContentCard };
